const PHOTOS = [
  { src: "/images/waiting-room.jpg", alt: "The waiting room at Advantage Primary Health" },
  { src: "/images/pediatric-room.jpg", alt: "The pediatric exam room at Advantage Primary Health" },
  { src: "/images/exam-room.jpg", alt: "An exam room at Advantage Primary Health" },
  { src: "/images/care-desk.jpg", alt: "The care coordination desk at Advantage Primary Health" },
  { src: "/images/clinic-interior.jpg", alt: "The welcome area at Advantage Primary Health" },
];

export default function PhotoStrip() {
  const row = [...PHOTOS, ...PHOTOS];
  return (
    <section
      data-testid="photo-strip"
      aria-label="Inside our clinic"
      className="border-y border-slate-100 bg-white py-8"
    >
      <p
        data-testid="photo-strip-swipe-hint"
        className="mb-4 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 sm:hidden"
      >
        Inside our clinic · swipe
      </p>
      <div className="overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:overflow-hidden">
        <div className="flex w-max animate-none sm:animate-marquee sm:[animation-duration:45s] sm:hover:[animation-play-state:paused]">
          {row.map((photo, i) => (
            <img
              key={i}
              src={photo.src}
              alt={i < PHOTOS.length ? photo.alt : ""}
              aria-hidden={i >= PHOTOS.length}
              loading="lazy"
              className="mr-5 h-48 w-auto rounded-2xl object-cover shadow-soft sm:h-56 lg:h-64"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
